import axios from "axios";
import type { ReceiverCandidate } from "@/models/receiverCandidate";

export const createDistributionForAllSuppliers = async (
  questionnaireId: string
): Promise<string> => {
  const response = await axios.post(
    "/api/distribution/create-for-all-suppliers",
    { questionnaireId }
  );
  return response.data;
};

export const createDistribution = async (
  questionnaireId: string,
  receiverCandidates: ReceiverCandidate[],
  dueDate: Date
): Promise<void> => {
  await axios.post("/api/distribution", receiverCandidates, {
    params: { questionnaireId, dueDate },
  });
};

export const createDistributions = async (
  questionnaireIds: string[],
  receiverCandidates: ReceiverCandidate[],
  dueDate: Date
): Promise<void> => {
  const requestBody: CreateDistributionsRequest = {
    questionnaireIds: questionnaireIds,
    receiverCandidates: receiverCandidates,
    dueDate: dueDate,
  };

  await axios.post("/api/distributions", requestBody);
};

export const getReceiverCandidatesForQuestionnaire = async (
  questionnaireId: string
): Promise<ReceiverCandidate[]> => {
  const response = await axios.get("/api/distribution/receiver-candidates", {
    params: { questionnaireId },
  });
  return response.data;
};

interface CreateDistributionsRequest {
  questionnaireIds: string[];
  receiverCandidates: ReceiverCandidate[];
  dueDate: Date;
}
